import axiosConfig from "../configs/axiosConfig";

export const apiSendEmail = async (payload) => {
  try {
    const response = await axiosConfig({
      method: "POST",
      url: `/contact/contact.php`,
      data: payload,
    });
    return response;
  } catch (error) {
    console.log(error);
    return "Fail";
  }
};
